'use client';

import { createContext } from 'react';

import type { ToggleButtonRootContextInterface } from '../types/toggle-button-root.types';

export const ToggleButtonRootContext = createContext<ToggleButtonRootContextInterface>({});

ToggleButtonRootContext.displayName = 'ToggleButton.Root.Context';
